// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#back_button[data-v-0e06a89f]{border:1px solid gray;transition:.1s ease-in-out;text-transform:uppercase;font-weight:bold;padding:1em 2em;text-align:center;border-radius:5px}#back_button[data-v-0e06a89f]:hover{transform:scale(1.02);cursor:pointer}", ""]);
// Exports
module.exports = exports;
